// PostHog arrives through GTM, after cookie consent, and often after the app already knows who
// is signed in. window.posthog?.x() then does nothing, silently. These queue until it loads.
const WAIT_MS = 60_000;
const POLL_MS = 500;

const queue = [];
let timer = null;
// Set by a sign-out, cleared when a sign-in starts: a /me that was already in flight at sign-out
// must not re-identify who just left, but the next sign-in on the same tab must be identified.
let signedOut = false;

// eslint-disable-next-line no-underscore-dangle
const loaded = () => Boolean(window.posthog && window.posthog.__loaded);

function flush() {
  queue.splice(0).forEach((call) => call(window.posthog));
}

function withPosthog(call) {
  if (loaded()) {
    call(window.posthog);
    return;
  }
  queue.push(call);
  if (timer) return;
  const started = Date.now();
  timer = setInterval(() => {
    if (loaded()) {
      clearInterval(timer);
      timer = null;
      flush();
    } else if (Date.now() - started > WAIT_MS) {
      // No consent, or the tag never fired: nothing to send to.
      clearInterval(timer);
      timer = null;
      queue.length = 0;
    }
  }, POLL_MS);
}

// The one place a signed-in user is tied to their anonymous history (the sales page included).
export function identifyUser(user) {
  if (!user?.id || signedOut) return;
  withPosthog((posthog) => {
    posthog.identify(String(user.id), { email: user.email, steam_id: user.steam_id });
  });
}

export function trackEvent(name, properties) {
  withPosthog((posthog) => posthog.capture(name, properties));
}

// On a real sign-out only: the next person on this browser starts anonymous.
export function resetAnalytics() {
  signedOut = true;
  withPosthog((posthog) => posthog.reset());
}

// Called as a sign-in starts (email, register, Steam), before its /me.
export function signInStarted() {
  signedOut = false;
}

// For tests.
export function resetQueueForTests() {
  signedOut = false;
  queue.length = 0;
  if (timer) clearInterval(timer);
  timer = null;
}
